var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.role,_vm._b({tag:"div",staticClass:"btn",class:_vm.getClasses,on:{"click":function($event){return _vm.$emit('click')}}},'div',_vm.$attrs,false),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }